import React, { Component } from 'react'
import { withAuth } from '../AuthContext'
import { Link, withRouter } from 'react-router-dom'
import Cards from 'react-credit-cards-2'
import 'react-credit-cards-2/dist/es/styles-compiled.css'
import Payment from 'payment'
import Cookies from 'universal-cookie'
import { loadStripe } from '@stripe/stripe-js'
import { setPricing, getCurrencySign } from '../../utils/utils'
import { decode } from 'html-entities'

const stripeKey = window.location.origin.includes('localhost')
  ? 'pk_test_518KDziCpZYiw17LY2MYtYdH9etP4Z0M0sHGKsoHMy7x7uavW3cN8mfpTEgiZPwGSc0rx32ZDCMv9g1E4JJmBCq1S00ASeexo7s'
  : 'pk_live_518KDziCpZYiw17LYRTUhBuTjHhAESPtj5SDtaZNXYYmco9GYuTcuNvErxtdJgzOnSpDaTmZn9xY7pTIwfQiAhipy004T59e1Mj'
const stripePromise = loadStripe(stripeKey)
const cookies = new Cookies()

class PlaceBooking extends Component {
  constructor(props) {
    super(props)
    const u = this.props.auth.user
    this.state = {
      voucherCode: '',
      name: u.forename + ' ' + u.surname,
      number: '4242424242424242',
      expiry: '',
      cvc: '',
      focused: '',
      errorText: '',
      loading: false,
      responseMessage: null,
      membership: {
        membershipFee: 0,
        feeSlug: '',
      },
      user: u,
      currencySign: null,
      place: {},
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputFocus = this.handleInputFocus.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props

    if (this.state.user.id === '') {
      this.props.history.push(`/place/${params.id}`)
    }

    //this.props.auth.refreshUser();

    Payment.formatCardNumber(document.querySelector('[name="number"]'))
    Payment.formatCardExpiry(document.querySelector('[name="expiry"]'))
    Payment.formatCardCVC(document.querySelector('[name="cvc"]'))
    const getPricing = async () => {
      const data = await setPricing(
        this.state.user.currencyValue,
        this.state.user.discountCode
      )
      this.setState({ membership: data })
    }
    const getCurrency = async () => {
      const data = await getCurrencySign(this.state.user.currencyValue)
      this.setState({ currencySign: data.sign })
    }
    getPricing()
    getCurrency()
    this.getPlace(params.id)
  }

  getPlace(id) {
    axios
      .get(`/api/place/${id}`)
      .then((response) => {
        const place = response.data.data
        this.setState({ place })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })
  }

  handleInputChange({ target }) {
    if (target.name === 'number') {
      this.setState({
        [target.name]: target.value.replace(/ /g, ''),
      })
    } else if (target.name === 'expiry') {
      this.setState({
        [target.name]: target.value.replace(/ |\//g, ''),
      })
    } else {
      this.setState({
        [target.name]: target.value,
      })
    }
  }

  handleInputFocus({ target }) {
    this.setState({
      focused: target.name,
    })
  }

  handleSubmit() {
    this.setState({
      errorText: '',
      loading: true,
    })
    const paymentDetails = {
      name: this.state.name,
      card_no: this.state.number,
      ccExpiryMonth: this.state.expiry.slice(0, 2),
      ccExpiryYear: this.state.expiry.slice(2, 4),
      cvcNumber: this.state.cvc,
      voucherCode: this.state.voucherCode,
      type: 'booking',
      amount: this.state.place.price,
      currency: this.props.auth.user.currencyValue,
      bookingRequest: this.props.location.state.bookingRequest.id,
    }

    const headers = {
      'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    }

    axios
      .post('/api/payment/stripeIntent', paymentDetails, headers)
      .then((response) => {
        if (!response.data.success) {
          if (response.data.error == 'requires_source_action') {
            this.setState({
              errorText:
                'More information is required to complete your transaction. Please wait...',
            })
            sCP(
              stripeKey,
              response.data.clientSecret,
              this,
              function (tS, err) {
                if (!err.error) {
                  tS.setState({
                    responseMessage:
                      'Your subscription has been created successfully',
                    loading: false,
                  })

                  const that = tS
                  setTimeout(function () {
                    that.setState({ responseMessage: 'Redirecting...' })
                    setTimeout(function () {
                      that.props.history.push(
                        `/place/${that.state.place.id}/booking/paid`,
                        {
                          bookingRequest:
                            that.props.location.state.bookingRequest,
                        }
                      )
                    }, 1000)
                  }, 1000)
                } else {
                  tS.setState({
                    errorText: err.error.message,
                    loading: false,
                  })
                }
              }
            )
          } else {
            this.setState({
              errorText: response.data.error,
              loading: false,
            })
          }
        } else {
          this.props.auth.refreshUser()
          this.setState({
            responseMessage: 'Your subscription has been created successfully',
            loading: false,
          })
          setTimeout(() => {
            this.setState({ responseMessage: 'Redirecting...' })
            setTimeout(() => {
              this.props.history.push(
                `/place/${this.state.place.id}/booking/paid`,
                {
                  bookingRequest: this.props.location.state.bookingRequest,
                }
              )
            }, 1000)
          }, 1000)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  render() {
    // Alternatively - could use https://github.com/stripe/react-stripe-elements
    const bookingRequestData = this.props.location.state.bookingRequest
    return (
      <section className="contact-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="contact_form">
                <h3 className="title">Booking</h3>
                <p>
                  Please provide details of your credit or debit card for
                  processing payment.
                </p>

                <div className="col-12  form-group">
                  <Cards
                    number={this.state.number}
                    name={this.state.name}
                    expiry={this.state.expiry}
                    cvc={this.state.cvc}
                    focused={this.state.focused}
                    // callback={this.handleCallback}
                    locale={{ valid: 'expiry' }}
                  />
                  <form
                    method="POST"
                    action="/"
                    name="myForm"
                    aria-label="Pay fee"
                    onSubmit={(event) => {
                      event.preventDefault()
                      this.handleSubmit()
                      return false
                    }}
                  >
                    <div className="col-12 form-group">
                      <label>Card number</label>
                      <input
                        type="tel"
                        name="number"
                        placeholder="0000 0000 0000 0000"
                        onKeyUp={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                      />
                    </div>
                    <div className="col-12 form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        onKeyUp={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                        onChange={this.handleInputChange}
                        value={this.state.name}
                      />
                    </div>
                    <div className="col-12 form-group">
                      <label>Expiry date</label>
                      <input
                        type="tel"
                        name="expiry"
                        placeholder="MM/YY"
                        onKeyUp={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                      />
                    </div>
                    <div className="col-12 form-group">
                      <label>CVC</label>
                      <input
                        type="tel"
                        name="cvc"
                        placeholder="CVC"
                        onKeyUp={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                      />
                    </div>
                    <div className="col-12 form-group">
                      <label>Voucher Code (optional)</label>
                      <input
                        type="text"
                        name="voucherCode"
                        placeholder="CODE"
                        onKeyUp={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                      />
                    </div>
                    <div
                      className="col-12 form-group"
                      style={{
                        visibility: this.state.errorText ? 'visible' : 'hidden',
                      }}
                    >
                      <label style={{ color: 'red' }}>
                        {this.state.errorText}
                      </label>
                    </div>
                    <div className="submit-btn">
                      {this.state.loading ? (
                        <button
                          className="btn btn-primary"
                          type="button"
                          disabled
                        >
                          Paying{' '}
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary">
                          Book for{' '}
                          {decode(this.state.place.currency) +
                            (
                              +bookingRequestData.fee *
                              bookingRequestData.nights
                            ).toFixed(2)}
                        </button>
                      )}
                      <Link
                        to="/dashboard"
                        className="btn btn-warning text-decoration-none ml-2"
                      >
                        Return
                      </Link>
                    </div>
                    {this.state.responseMessage && (
                      <div className="submit-btn">
                        <span className="text-muted">
                          {this.state.responseMessage}
                        </span>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(withAuth(PlaceBooking))
